import React, { memo, useMemo } from 'react';
import { CalendarScheduleFrom } from '@demind-inc/core';
import { Box, Stack } from '@mui/material';
import LinearHorizontalBG from '../../../../assets/common/linear-horizontal-bg_opaque.png';
import SleepBG from '../../../../assets/calendar/suggestions/sleep_block_bg.png';
import MealBG from '../../../../assets/calendar/suggestions/meal_block_bg.png';
import './EventImageBgWrapper.scss';

interface EventImageBgWrapperProps {
  children: React.ReactNode;
  showBg: boolean;
  type?: CalendarScheduleFrom;
  className?: string;
  color?: string;
}

const EventImageBgWrapper: React.FC<EventImageBgWrapperProps> = memo(
  ({ children, showBg, type, className, color }) => {
    const bgImage = useMemo(() => {
      if (type === 'sleep') {
        return SleepBG;
      }
      if (type === 'meal') {
        return MealBG;
      }

      return LinearHorizontalBG;
    }, [type]);

    const todoBgStyle = useMemo(() => {
      if (['todo', 'routine'].includes(type) && color) {
        return {
          backgroundImage: `repeating-linear-gradient(
            -45deg,
            transparent,
            transparent 7px,
            ${color} 7px,
            ${color} 8px
          )`,
          opacity: 0.1,
        };
      }
      return {};
    }, [type, color]);

    const todoBaseColorStyle = useMemo(() => {
      if (['todo', 'routine'].includes(type) && color) {
        return {
          backgroundColor: color,
          opacity: 0.05,
        };
      }
      return {};
    }, [type, color]);

    if (!showBg || !type) {
      return <>{children}</>;
    }

    return (
      <Stack position="relative" flex={1} width="100%" borderRadius={1}>
        {['todo', 'routine'].includes(type) ? (
          <>
            <Box className="event-image-bg-wrapper__todo-base" style={todoBaseColorStyle} />
            <Box className="event-image-bg-wrapper__todo-bg" style={todoBgStyle} />
          </>
        ) : (
          <img className="event-image-bg-wrapper__image" src={bgImage} />
        )}
        <Box className={className}>{children}</Box>
      </Stack>
    );
  }
);

export default EventImageBgWrapper;
